import { render, staticRenderFns } from "./ViewRequestDetail.vue?vue&type=template&id=0276b1aa&scoped=true&"
import script from "./ViewRequestDetail.vue?vue&type=script&lang=js&"
export * from "./ViewRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./ViewRequestDetail.vue?vue&type=style&index=0&id=0276b1aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0276b1aa",
  null
  
)

export default component.exports